import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import cn from "classnames";
import { navigate } from "./constants";
import * as dateMath from "date-arithmetic";
// import "antd/lib/popover/style/index.css";
import Calendar from "antd/lib/calendar";
// import "antd/lib/calendar/style/index.css";
import * as instructorActions from '../../_actions/roster.actions'
import { CALENDAR_VIEWS } from "./constants";
import { viewConstants } from "../../_constants/view.constants";

class Toolbar extends React.Component {
  static propTypes = {
    view: PropTypes.string.isRequired,
    views: PropTypes.arrayOf(PropTypes.string).isRequired,
    label: PropTypes.node.isRequired,
    localizer: PropTypes.object,
    onNavigate: PropTypes.func.isRequired,
    onView: PropTypes.func.isRequired
  };

  render() {
    let {
      localizer: { messages },
      label,
      view
    } = this.props;

    let popover = (
      <div className="popover-calendar">
        <Calendar fullscreen={false} onSelect={this.onSelect} />
      </div>
    );

    return (
      <div className="rbc-toolbar">
        <span className="rbc-btn-group">
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.PREVIOUS)}
          >
            <i className="fas fa-angle-double-left" />
          </button>
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.TODAY)}
          >
            {messages.today}
          </button>
          <button
            type="button"
            onClick={this.navigate.bind(null, navigate.NEXT)}
          >
            <i className="fas fa-angle-double-right" />
          </button>
        </span>

        <span className="rbc-toolbar-label">{label}</span>

        <span className="rbc-btn-group">{this.viewNamesGroup(messages)}</span>
      </div>
    );
  }

  navigate = action => {
    const newDate = this.rangeChange(this.props.date, action, this.props.view);

    const options = {
      range: this.props.view || viewConstants.MONTH,
      time: newDate || new Date()
    };
    this.props.actions.etimeActions.fetchCurrentUserETime(options);
    // Fetch roster data from server
    // Prev = fetch roster data one month before the current adjusted month
    // NEXT = fetch roster data one month after the current adjusted month
    this.props.onNavigate(action, this.props.date);
  };

  view = view => {
    this.props.onView(view);
  };

  rangeChange = (date, action, view) => {
    switch (view) {
      case CALENDAR_VIEWS.MONTH:
        return this.navigateMonth(date, action);

      case CALENDAR_VIEWS.WEEK:
        return this.navigateWeek(date, action);

      case CALENDAR_VIEWS.DAY:
        return this.navigateDay(date, action);

      default:
        return date;
    }
  };

  navigateMonth = (date, action) => {
    switch (action) {
      case navigate.PREVIOUS:
        return dateMath.add(date, -1, "month");

      case navigate.NEXT:
        return dateMath.add(date, 1, "month");

      default:
        return date;
    }
  };

  navigateWeek = (date, action) => {
    switch (action) {
      case navigate.PREVIOUS:
        return dateMath.add(date, -1, "week");

      case navigate.NEXT:
        return dateMath.add(date, 1, "week");

      default:
        return date;
    }
  };

  navigateDay = (date, action) => {
    switch (action) {
      case navigate.PREVIOUS:
        return dateMath.add(date, -1, "day");

      case navigate.NEXT:
        return dateMath.add(date, 1, "day");

      default:
        return date;
    }
  };

  viewNamesGroup(messages) {
    let viewNames = this.props.views;
    const view = this.props.view;

    if (viewNames.length > 1) {
      return viewNames.map(name => (
        <button
          type="button"
          key={name}
          className={cn({ "rbc-active": view === name })}
          onClick={this.view.bind(null, name)}
        >
          {messages[name]}
        </button>
      ));
    }
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      etimeActions: bindActionCreators(instructorActions, dispatch)
    }
  };
}

export default connect(null, mapDispatchToProps)(Toolbar);
